import { Injectable, signal } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class UserStateService {
  private _entorno = signal<string>(sessionStorage.getItem("entorno") || "");
  private _usuario = signal<string>(sessionStorage.getItem("usuario") || "");
  private _rol = signal<string>(sessionStorage.getItem("descnivelportal") || "");
  private _isAuthenticated = signal<boolean>(!!sessionStorage.getItem("dusuario"));
  private _usuarioGestion = signal<string>(sessionStorage.getItem("usuario") || "");
  private _dusuario = signal<string>(sessionStorage.getItem("dusuario") || "");
  private _organization = signal<string>(sessionStorage.getItem("organization") || "");

  public readonly entorno = this._entorno.asReadonly();
  public readonly usuario = this._usuario.asReadonly();
  public readonly rol = this._rol.asReadonly();
  public readonly isAuthenticated = this._isAuthenticated.asReadonly();
  public readonly usuarioGestion = this._usuarioGestion.asReadonly();
  public readonly dusuario = this._dusuario.asReadonly();
  public readonly organization = this._organization.asReadonly();

  public initializeFromSession(): void {
    this._entorno.set(sessionStorage.getItem("entorno") || "");
    this._usuario.set(sessionStorage.getItem("usuario") || "");
    this._rol.set(sessionStorage.getItem("descnivelportal") || "");
    this._isAuthenticated.set(!!sessionStorage.getItem("usuario"));
    this._usuarioGestion.set(sessionStorage.getItem("usuario") || "");
  }

  public updateUserInfo(userData: {
    entorno?: string;
    usuario?: string;
    rol?: string;
    dusuario?: string;
    organization?: string;
  }): void {
    if (userData.entorno) {
      this._entorno.set(userData.entorno);
      sessionStorage.setItem("entorno", userData.entorno);
    }

    if (userData.usuario) {
      this._usuario.set(userData.usuario);
      sessionStorage.setItem("usuario", userData.usuario);
    }

    if (userData.rol) {
      this._rol.set(userData.rol);
      sessionStorage.setItem("descnivelportal", userData.rol);
    }

    if (userData.dusuario) {
      this._dusuario.set(userData.dusuario);
      this._usuarioGestion.set(userData.dusuario);
      sessionStorage.setItem("dusuario", userData.dusuario);
    }

    if (userData.organization) {
      this._organization.set(userData.organization);
      sessionStorage.setItem("organization", userData.organization);
    }

    this._isAuthenticated.set(!!this._usuario());
  }

  public clearUserState(): void {
    sessionStorage.removeItem("entorno");
    sessionStorage.removeItem("dusuario");
    sessionStorage.removeItem("descnivelportal");
    sessionStorage.removeItem("usuario");
    sessionStorage.removeItem("organization");

    this._entorno.set("");
    this._usuario.set("");
    this._rol.set("");
    this._dusuario.set("");
    this._usuarioGestion.set("");
    this._organization.set("");
    this._isAuthenticated.set(false);
  }
}
